// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-panel {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 24px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.search-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Main row - Unified Search */
.search-main-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  flex: 1 1; /* Stretch */
  min-width: 200px;
  display: flex;
  align-items: center;
}

.search-secondary-filter-wrapper {
  position: relative;
  flex: 0.6 1; /* Take less space than the main input */
  min-width: 220px;
  max-width: 300px;
  display: flex;
  align-items: center;
}

.search-input-icon {
  position: absolute;
  left: 12px;
  color: var(--text-secondary);
  opacity: 0.7;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2; /* Ensure it stays on top */
}

.search-panel .filter-input.with-icon {
  padding-left: 38px; /* Room for icon */
  height: 42px;
  font-size: 0.95rem;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.02);
  position: relative;
  z-index: 1;
}

.search-panel .filter-select.main-status {
  width: 180px;
  height: 42px;
  background-color: var(--bg-secondary);
  border-radius: 10px;
}

.search-actions-unified {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Secondary Row - Expandable Filters */
.search-secondary-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  padding-top: 12px;
  border-top: 1px dashed var(--border-color);
}

.search-panel .filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.search-panel .filter-label {
  font-family: var(--font-data);
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 4px;
}

.search-panel .filter-input,
.search-panel .filter-select {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  font-family: var(--font-body);
  font-size: 0.9rem;
  color: var(--text-primary);
  background-color: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-panel .filter-input:focus,
.search-panel .filter-select:focus {
  border-color: var(--accent-primary);
  background-color: var(--bg-primary);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* Buttons */
.btn-toggle-filters,
.btn-reset-filters {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 12px;
  border-radius: 10px;
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  gap: 6px;
}

.btn-toggle-filters:hover,
.btn-reset-filters:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-color: var(--text-secondary);
}

.btn-toggle-filters.active {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

@media (max-width: 992px) {
  .search-main-row {
    flex-wrap: wrap;
  }
  .search-panel .filter-select.main-status {
    width: 150px;
    flex-grow: 1;
  }
}

@media (max-width: 640px) {
  .search-main-row {
    flex-direction: column;
    align-items: stretch;
  }
  .search-panel .filter-select.main-status {
    width: 100%;
  }
  .search-actions-unified {
    justify-content: space-between;
  }
}

/*
 * Кнопка «Сбросить» — два режима:
 * - по умолчанию: сероватая (есть только повтор запроса / пустое состояние);
 * - --active: есть что сбрасывать — лёгкая подсветка в стиле панели.
 */
.search-panel-reset-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  height: 42px;
  padding: 0 14px;
  border-radius: 10px;
  font-family: var(--font-body);
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
  border: 1px solid var(--border-color, #e2e8f0);
  background: var(--bg-tertiary, #f1f5f9);
  color: var(--text-secondary, #64748b);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.search-panel-reset-btn svg {
  color: var(--text-secondary, #94a3b8);
  opacity: 0.95;
  flex-shrink: 0;
}

.search-panel-reset-btn:hover:not(:disabled) {
  border-color: #cbd5e1;
  background: #e8edf3;
  color: #475569;
}

.search-panel-reset-btn:hover:not(:disabled) svg {
  color: #64748b;
}

.search-panel-reset-btn:focus-visible:not(:disabled) {
  outline: none;
  border-color: rgba(59, 130, 246, 0.45);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);
}

.search-panel-reset-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Есть активные фильтры — заметнее, в тон accent */
.search-panel-reset-btn--active:not(:disabled) {
  border-color: rgba(59, 130, 246, 0.42);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: var(--accent-primary);
  box-shadow:
    0 0 0 1px rgba(59, 130, 246, 0.12),
    0 1px 3px rgba(59, 130, 246, 0.12);
}

.search-panel-reset-btn--active:not(:disabled) svg {
  color: var(--accent-primary);
  opacity: 1;
}

.search-panel-reset-btn--active:hover:not(:disabled) {
  border-color: rgba(59, 130, 246, 0.55);
  background: linear-gradient(180deg, #f8fafc 0%, #eff6ff 100%);
  color: var(--accent-primary);
  box-shadow:
    0 0 0 1px rgba(59, 130, 246, 0.18),
    0 2px 6px rgba(59, 130, 246, 0.15);
}

.search-panel-reset-btn--active:focus-visible:not(:disabled) {
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.22),
    0 1px 3px rgba(59, 130, 246, 0.15);
}

.search-status-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* Старый layout: поиск + сброс */
.search-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: var(--font-body);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--border-color);
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.search-btn-primary {
  background: var(--accent-primary);
  color: #fff;
  border-color: var(--accent-primary);
}

.search-btn-primary:hover:not(:disabled) {
  filter: brightness(1.05);
}

.search-btn-reset {
  font-weight: 500;
  border: 1px solid var(--border-color, #e2e8f0);
  background: var(--bg-tertiary, #f1f5f9);
  color: var(--text-secondary, #64748b);
}

.search-btn-reset svg {
  color: var(--text-secondary, #94a3b8);
}

.search-btn-reset:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.search-btn-reset:hover:not(:disabled) {
  border-color: #cbd5e1;
  background: #e8edf3;
  color: #475569;
}

.search-btn-reset--active:not(:disabled) {
  border-color: rgba(59, 130, 246, 0.42);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: var(--accent-primary);
  box-shadow:
    0 0 0 1px rgba(59, 130, 246, 0.12),
    0 1px 3px rgba(59, 130, 246, 0.12);
}

.search-btn-reset--active:not(:disabled) svg {
  color: var(--accent-primary);
}

.search-btn-reset--active:hover:not(:disabled) {
  border-color: rgba(59, 130, 246, 0.55);
  background: linear-gradient(180deg, #f8fafc 0%, #eff6ff 100%);
  color: var(--accent-primary);
  box-shadow:
    0 0 0 1px rgba(59, 130, 246, 0.18),
    0 2px 6px rgba(59, 130, 246, 0.15);
}
/* Тёмная тема (DEV): текст кнопок сброса при ховере сливался,
   активные кнопки имели белый градиент. */
:root[data-theme='dark'] .search-panel-reset-btn:hover:not(:disabled),
:root[data-theme='dark'] .search-btn-reset:hover:not(:disabled) {
  color: var(--text-primary);
}

:root[data-theme='dark'] .search-panel-reset-btn--active:not(:disabled),
:root[data-theme='dark'] .search-btn-reset--active:not(:disabled) {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

:root[data-theme='dark'] .search-panel-reset-btn--active:hover:not(:disabled),
:root[data-theme='dark'] .search-btn-reset--active:hover:not(:disabled) {
  background: var(--bg-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/css/search-panel.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAO,EAAE,YAAY;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAS,EAAE,wCAAwC;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,kBAAkB,EAAE,kBAAkB;EACtC,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;;EAEE,mCAAmC;EACnC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;;EAEE,8BAA8B;EAC9B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;;;;EAIE;AACF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf;;;;wBAIsB;EACtB,8CAA8C;EAC9C,uCAAuC;EACvC,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,4BAA4B;EAC5B;;sCAEoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,4BAA4B;EAC5B;;sCAEoC;AACtC;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,yEAAyE;AAC3E;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,4BAA4B;EAC5B;;sCAEoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,4BAA4B;EAC5B;;sCAEoC;AACtC;AACA;0CAC0C;AAC1C;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":[".search-panel {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.search-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Main row - Unified Search */\n.search-main-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.search-input-wrapper {\n  position: relative;\n  flex: 1; /* Stretch */\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n}\n\n.search-secondary-filter-wrapper {\n  position: relative;\n  flex: 0.6; /* Take less space than the main input */\n  min-width: 220px;\n  max-width: 300px;\n  display: flex;\n  align-items: center;\n}\n\n.search-input-icon {\n  position: absolute;\n  left: 12px;\n  color: var(--text-secondary);\n  opacity: 0.7;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2; /* Ensure it stays on top */\n}\n\n.search-panel .filter-input.with-icon {\n  padding-left: 38px; /* Room for icon */\n  height: 42px;\n  font-size: 0.95rem;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,0.02);\n  position: relative;\n  z-index: 1;\n}\n\n.search-panel .filter-select.main-status {\n  width: 180px;\n  height: 42px;\n  background-color: var(--bg-secondary);\n  border-radius: 10px;\n}\n\n.search-actions-unified {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Secondary Row - Expandable Filters */\n.search-secondary-filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  padding-top: 12px;\n  border-top: 1px dashed var(--border-color);\n}\n\n.search-panel .filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.search-panel .filter-label {\n  font-family: var(--font-data);\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding-left: 4px;\n}\n\n.search-panel .filter-input,\n.search-panel .filter-select {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  background-color: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.search-panel .filter-input:focus,\n.search-panel .filter-select:focus {\n  border-color: var(--accent-primary);\n  background-color: var(--bg-primary);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n/* Buttons */\n.btn-toggle-filters,\n.btn-reset-filters {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-family: var(--font-body);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  border: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  gap: 6px;\n}\n\n.btn-toggle-filters:hover,\n.btn-reset-filters:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border-color: var(--text-secondary);\n}\n\n.btn-toggle-filters.active {\n  background: var(--accent-primary);\n  color: white;\n  border-color: var(--accent-primary);\n}\n\n@media (max-width: 992px) {\n  .search-main-row {\n    flex-wrap: wrap;\n  }\n  .search-panel .filter-select.main-status {\n    width: 150px;\n    flex-grow: 1;\n  }\n}\n\n@media (max-width: 640px) {\n  .search-main-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .search-panel .filter-select.main-status {\n    width: 100%;\n  }\n  .search-actions-unified {\n    justify-content: space-between;\n  }\n}\n\n/*\n * Кнопка «Сбросить» — два режима:\n * - по умолчанию: сероватая (есть только повтор запроса / пустое состояние);\n * - --active: есть что сбрасывать — лёгкая подсветка в стиле панели.\n */\n.search-panel-reset-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-shrink: 0;\n  height: 42px;\n  padding: 0 14px;\n  border-radius: 10px;\n  font-family: var(--font-body);\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition:\n    border-color 0.2s ease,\n    background 0.2s ease,\n    color 0.2s ease,\n    box-shadow 0.2s ease;\n  border: 1px solid var(--border-color, #e2e8f0);\n  background: var(--bg-tertiary, #f1f5f9);\n  color: var(--text-secondary, #64748b);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\n}\n\n.search-panel-reset-btn svg {\n  color: var(--text-secondary, #94a3b8);\n  opacity: 0.95;\n  flex-shrink: 0;\n}\n\n.search-panel-reset-btn:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background: #e8edf3;\n  color: #475569;\n}\n\n.search-panel-reset-btn:hover:not(:disabled) svg {\n  color: #64748b;\n}\n\n.search-panel-reset-btn:focus-visible:not(:disabled) {\n  outline: none;\n  border-color: rgba(59, 130, 246, 0.45);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);\n}\n\n.search-panel-reset-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Есть активные фильтры — заметнее, в тон accent */\n.search-panel-reset-btn--active:not(:disabled) {\n  border-color: rgba(59, 130, 246, 0.42);\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  color: var(--accent-primary);\n  box-shadow:\n    0 0 0 1px rgba(59, 130, 246, 0.12),\n    0 1px 3px rgba(59, 130, 246, 0.12);\n}\n\n.search-panel-reset-btn--active:not(:disabled) svg {\n  color: var(--accent-primary);\n  opacity: 1;\n}\n\n.search-panel-reset-btn--active:hover:not(:disabled) {\n  border-color: rgba(59, 130, 246, 0.55);\n  background: linear-gradient(180deg, #f8fafc 0%, #eff6ff 100%);\n  color: var(--accent-primary);\n  box-shadow:\n    0 0 0 1px rgba(59, 130, 246, 0.18),\n    0 2px 6px rgba(59, 130, 246, 0.15);\n}\n\n.search-panel-reset-btn--active:focus-visible:not(:disabled) {\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.22),\n    0 1px 3px rgba(59, 130, 246, 0.15);\n}\n\n.search-status-wrapper {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* Старый layout: поиск + сброс */\n.search-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid var(--border-color);\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.search-btn-primary {\n  background: var(--accent-primary);\n  color: #fff;\n  border-color: var(--accent-primary);\n}\n\n.search-btn-primary:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.search-btn-reset {\n  font-weight: 500;\n  border: 1px solid var(--border-color, #e2e8f0);\n  background: var(--bg-tertiary, #f1f5f9);\n  color: var(--text-secondary, #64748b);\n}\n\n.search-btn-reset svg {\n  color: var(--text-secondary, #94a3b8);\n}\n\n.search-btn-reset:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.search-btn-reset:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background: #e8edf3;\n  color: #475569;\n}\n\n.search-btn-reset--active:not(:disabled) {\n  border-color: rgba(59, 130, 246, 0.42);\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  color: var(--accent-primary);\n  box-shadow:\n    0 0 0 1px rgba(59, 130, 246, 0.12),\n    0 1px 3px rgba(59, 130, 246, 0.12);\n}\n\n.search-btn-reset--active:not(:disabled) svg {\n  color: var(--accent-primary);\n}\n\n.search-btn-reset--active:hover:not(:disabled) {\n  border-color: rgba(59, 130, 246, 0.55);\n  background: linear-gradient(180deg, #f8fafc 0%, #eff6ff 100%);\n  color: var(--accent-primary);\n  box-shadow:\n    0 0 0 1px rgba(59, 130, 246, 0.18),\n    0 2px 6px rgba(59, 130, 246, 0.15);\n}\n/* Тёмная тема (DEV): текст кнопок сброса при ховере сливался,\n   активные кнопки имели белый градиент. */\n:root[data-theme='dark'] .search-panel-reset-btn:hover:not(:disabled),\n:root[data-theme='dark'] .search-btn-reset:hover:not(:disabled) {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .search-panel-reset-btn--active:not(:disabled),\n:root[data-theme='dark'] .search-btn-reset--active:not(:disabled) {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .search-panel-reset-btn--active:hover:not(:disabled),\n:root[data-theme='dark'] .search-btn-reset--active:hover:not(:disabled) {\n  background: var(--bg-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
